import React from 'react';
import PropTypes from 'prop-types';

const SellerResponseTime = ({ responseTime, comma }) => (
    <span className="seller-response-time">
        {comma ? ', ' : ''}
        {responseTime} Avg Response Time
    </span>
);

SellerResponseTime.propTypes = {
    comma: PropTypes.bool,
    responseTime: PropTypes.string
};

export default SellerResponseTime;



// WEBPACK FOOTER //
// ./src/shared/seller_response_time/index.js